import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';
import { useAuth } from '../../../context/AuthContext';
import inboundApi from '../../../config/inboundApi';

export default function AddressFormModal({ show, onClose, editAddress }) {
  const { user } = useAuth();
  const subdomain = user?.subdomain || 'subdomain';
  const [localPart, setLocalPart] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [status, setStatus] = useState('active');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const isEdit = !!editAddress;

  useEffect(() => {
    if (editAddress) {
      setLocalPart(editAddress.local_part || '');
      setDisplayName(editAddress.display_name || '');
      setStatus(editAddress.status || 'active');
    } else {
      setLocalPart('');
      setDisplayName('');
      setStatus('active');
    }
    setError('');
  }, [editAddress, show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');

    try {
      if (isEdit) {
        await inboundApi.put(`/support-addresses/${editAddress.id}`, {
          display_name: displayName,
          status,
        });
        onClose('updated');
      } else {
        await inboundApi.post('/support-addresses', {
          local_part: localPart.toLowerCase(),
          display_name: displayName,
        });
        onClose('created');
      }
    } catch (err) {
      const detail = err.response?.data?.detail || 'Something went wrong';
      setError(detail);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={() => onClose(null)}>
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? 'Edit Address' : 'Add Support Address'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}

          <Form.Group className="mb-3">
            <Form.Label>Local Part</Form.Label>
            <Form.Control
              value={localPart}
              onChange={(e) => setLocalPart(e.target.value)}
              placeholder="support"
              disabled={isEdit}
              required
            />
            <Form.Text className="text-muted">
              The part before @. Full address will be: {localPart || 'name'}@{subdomain}.topcx.ai
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Display Name</Form.Label>
            <Form.Control
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              placeholder="Acme Support"
              required
            />
          </Form.Group>

          {isEdit && (
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </Form.Select>
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => onClose(null)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={saving || !localPart.trim() || !displayName.trim()}
          >
            {saving ? <Spinner size="sm" /> : isEdit ? 'Save Changes' : 'Create'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
